
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class SpecSheetLaborGrid extends Serenity.EntityGrid<SpecSheetLaborRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.SpecSheetLabor'; }
        protected getIdProperty() { return SpecSheetLaborRow.idProperty; }
        protected getInsertPermission() { return SpecSheetLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return SpecSheetLaborRow.localTextPrefix; }
        protected getService() { return SpecSheetLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}